import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Elegant Founding Beta badge — used inside layouts (top bar) to subtly remind
 * users they have complimentary access during the validation phase.
 */
const BetaBanner = ({ variant = 'banner' }) => {
  if (variant === 'inline') {
    return (
      <span
        className="inline-flex items-center gap-1.5 bg-primary/10 border border-primary/30 rounded-full px-2.5 py-0.5"
        data-testid="founding-beta-badge"
      >
        <Sparkles size={10} className="text-primary" />
        <span className="text-[10px] uppercase tracking-widest text-primary font-semibold">Founding Beta</span>
      </span>
    );
  }

  // Full-width subtle banner (used as a top-of-page indicator)
  return (
    <div
      className="bg-primary/5 border-b border-primary/15 px-4 py-1.5 text-center relative z-40"
      data-testid="founding-beta-banner"
    >
      <div className="flex items-center justify-center gap-2 text-primary text-xs">
        <Sparkles size={12} className="text-primary" />
        <span className="font-semibold uppercase tracking-widest text-[10px]">Founding Beta Access</span>
        <span className="hidden sm:inline text-primary/70 text-[11px] normal-case tracking-normal">
          — Complimentary access while Meybra evolves through real-world validation.
        </span>
      </div>
    </div>
  );
};

export default BetaBanner;
